/**
 * Document fields a browser search never receives. The stored vector is useless to the client, and
 * the `businessEntities` contact arrays are contact PII that only server-side resolution reads.
 * Every web Typesense request sends this as `exclude_fields`; a test pins each `contact*` field of
 * the `businessEntities` schema against it.
 */
export const BROWSER_EXCLUDED_SEARCH_FIELDS = [
  'embedding',
  'contactIds',
  'contactNames',
  'contactPhones',
  'contactEmails',
] as const;

export const BROWSER_EXCLUDE_FIELDS_PARAM = BROWSER_EXCLUDED_SEARCH_FIELDS.join(',');
